import {Grid} from "@mui/material";
import Formulario_Crear_Proyectos from "./Formulario_Crear_Proyectos";

const Crear_Proyecto_Dashboard = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container justifyContent={'center'}
                  alignItems={'flex-start'} size={{xs: 12, sm: 12, md: 12}} sx={{maxWidth: 1400, px:3}}>
                <Formulario_Crear_Proyectos/>
            </Grid>

        </Grid>
    )

}
export default Crear_Proyecto_Dashboard;